import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Messages } from 'primereact/messages';
import { useRef } from 'react';
import usuarioService from '../services/usuarioService';
import { hideProcessing, showProcessing } from '../utils/utils';

const ChangePasswordDialog = ({ visible, onHide, onSuccess }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const msgRef = useRef();

    const handleClose = () => {
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        onHide();
    };

    const validateForm = () => {
        if (!currentPassword || !newPassword || !confirmPassword) {
            msgRef.current.show({
                closable: false,
                severity: 'warn',
                summary: 'Aviso',
                detail: 'Preencha todos os campos obrigatórios',
            });
            return false;
        }

        if (newPassword.length < 6) {
            msgRef.current.show({
                closable: false,
                severity: 'warn',
                summary: 'Aviso',
                detail: 'A nova senha deve ter no mínimo 6 caracteres',
            });
            return false;
        }

        if (newPassword !== confirmPassword) {
            msgRef.current.show({
                closable: false,
                severity: 'warn',
                summary: 'Aviso',
                detail: 'As senhas não conferem',
            });
            return false;
        }

        return true;
    };

    const handleChangePassword = async () => {
        if (!validateForm()) {
            return;
        }

        setLoading(true);
        showProcessing();

        try {
            const response = await usuarioService.changePassword({
                senhaAtual: currentPassword,
                novaSenha: newPassword,
            });

            if (response.status === 200) {
                msgRef.current.show({
                    closable: false,
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Senha alterada com sucesso',
                });
                
                setTimeout(() => {
                    hideProcessing();
                    handleClose();
                    if (onSuccess) {
                        onSuccess();
                    }
                }, 1500);
            }
        } catch (error) {
            hideProcessing();
            setLoading(false);
            
            msgRef.current.show({
                closable: false,
                severity: 'error',
                summary: 'Erro',
                detail: error.response?.data?.message || 'Erro ao alterar senha',
            });
        }
    };

    const dialogFooter = (
        <div>
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={handleClose}
                className="p-button-text"
                disabled={loading}
            />
            <Button
                label="Alterar Senha"
                icon="pi pi-check"
                onClick={handleChangePassword}
                loading={loading}
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            style={{ width: '90vw', maxWidth: '450px' }}
            header="Alterar Senha"
            modal
            className="p-fluid"
            footer={dialogFooter}
            onHide={handleClose}
        >
            <Messages ref={msgRef} style={{ width: '100%', marginBottom: '1rem' }} />
            
            <div className="field">
                <label htmlFor="currentPassword" className="block mb-2 font-semibold">
                    Senha Atual *
                </label>
                <Password
                    id="currentPassword"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    toggleMask
                    disabled={loading}
                    placeholder="Digite sua senha atual"
                />
            </div>

            <div className="field">
                <label htmlFor="newPassword" className="block mb-2 font-semibold">
                    Nova Senha *
                </label>
                <Password
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    toggleMask
                    disabled={loading}
                    placeholder="Digite sua nova senha"
                    weakLabel="Fraca"
                    mediumLabel="Média"
                    strongLabel="Forte"
                />
            </div>

            <div className="field">
                <label htmlFor="confirmPassword" className="block mb-2 font-semibold">
                    Confirmar Nova Senha *
                </label>
                <Password
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    toggleMask
                    disabled={loading}
                    placeholder="Confirme sua nova senha"
                    feedback={false}
                />
            </div>
        </Dialog>
    );
};

export default ChangePasswordDialog;
